var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.000000, -79.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0,
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26992187,9.41474609 L13.9735352,9.41474609 C14.4549805,9.41474609 14.8451172,9.02626953 14.8451172,8.54814453 L14.8451172,8.5 C14.8451172,8.021875 14.4549805,7.63339844 13.9735352,7.63339844 L4.24833984,7.63339844 L7.15527344,4.71650391 C7.490625,4.37949219 7.490625,3.83662109 7.15527344,3.49960938 L7.14863281,3.49296875 C6.81328125,3.15595703 6.26708984,3.15263672 5.92675781,3.48466797 L5.91845703,3.49296875 L1.19199219,8.23603516 C1.0243127,8.40451724 1.0243127,8.67683041 1.19199219,8.8453125 L2.11669922,9.77333984 L5.84375,13.5103516 C6.18242187,13.8506836 6.73525391,13.8523437 7.07724609,13.5169922 L7.08388672,13.5103516 L7.11210937,13.4821289 C7.44912109,13.1451172 7.44912109,12.6005859 7.11210937,12.2635742 L4.26992187,9.41474609 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.2719d1e01efa0328fb5b7c2b8608f112.svg";
export { ForwardRef as ReactComponent };